<!-- This is the page a carrier sees when an onboarding link is sent to them -->
<template>
  <div class="uk-position-center uk-text-center uk-container">
    <h2>Thank you!</h2>
    <h3 class="uk-width-2-3 uk-align-center">
      Your onboarding is complete, and the forms have been sent to the broker. You can close this
      page.
    </h3>
    <h4 class="uk-width-2-3 uk-align-center">
      If you'd like to use Duplex for onboarding other companies yourself, then please contact us at <a href="mailto: team@duplexhq.com">team@duplexhq.com</a> to get an account and try it out! It's the <b>simplest</b> way to digitally onboard your partners.
    </h4>
    <!-- TOOD: add link to their shareable profile page for them to share and try out with others -->
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
// import UIkit from 'uikit';

export default defineComponent({
  name: 'OnboardingCompleted',
  components: {},
  data() {
    return {};
  },
  props: {},
  methods: {},
});
</script>
